import { render, staticRenderFns } from "./CreatePostVideosUploading.vue?vue&type=template&id=15f1f9ba&scoped=true&"
import script from "./CreatePostVideosUploading.vue?vue&type=script&lang=js&"
export * from "./CreatePostVideosUploading.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostVideosUploading.vue?vue&type=style&index=0&id=15f1f9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f1f9ba",
  null
  
)

export default component.exports